import { PAYMENT_ENDPOINTS } from '../../../utils/api/endpoints/paymentEndpoints';
import {
  UseSignaturePaymentENTParams,
  UseSignaturePaymentENTResponse,
} from './useSignaturePaymentENT.types';

const PREFIX = '[signaturePaymentENTQuery]';

export const querySignaturePaymentENT = async (params: UseSignaturePaymentENTParams) => {
  console.log(PREFIX, `Fetching signature payment ENT...`);
  const response = await PAYMENT_ENDPOINTS.signatureENT(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received signature payment ENT.`);
  return json as UseSignaturePaymentENTResponse;
};
